var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAccountPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#febe10;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.37,
    y: 0.46,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.37,
    y: 0.46,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "password"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M572.29,319.2V290q0-25.86-17.06-44T513.77,228H484.49v-49.2a168,168,0,0,0-25-89.06,183,183,0,0,0-67.68-65,185,185,0,0,0-87.66-24c-1.67,0-3.33-.06-5-.06q-50,0-92.67,24a183,183,0,0,0-67.68,65,167.6,167.6,0,0,0-23.63,67,176.57,176.57,0,0,0-1.37,22.06V228H84.52a55.24,55.24,0,0,0-21.69,4.17,50.44,50.44,0,0,0-6.39,3.15,55.5,55.5,0,0,0-8.74,6.33h0A62.52,62.52,0,0,0,43,246.05a61.06,61.06,0,0,0-9.85,13.65,59.18,59.18,0,0,0-5.87,16.41v0A69,69,0,0,0,26,290v29.13c0,.07,0,.13,0,.2v225a53.12,53.12,0,0,0,7.22,27.5A56.69,56.69,0,0,0,43,584.23a58,58,0,0,0,17.11,11.54,60,60,0,0,0,23.41,4.84l1,0H513.77l1.05,0q23.7-.36,40.41-16.38,17.07-16.41,17.07-39.86v-225C572.3,319.31,572.29,319.26,572.29,319.2Zm-361-140.45q0-35.16,25.62-59.76t62.18-24.62c1.69,0,3.35,0,5,.12q33.35,1.59,57.17,24.5,25.64,24.6,25.62,59.76V228H211.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.29,362.68c0-34.58-29.16-62.61-65.14-62.61S239,328.1,239,362.68a61.46,61.46,0,0,0,22.61,47.39v87.86a42.66,42.66,0,0,0,42.53,42.54h0a42.66,42.66,0,0,0,42.53-42.54V410.07A61.46,61.46,0,0,0,369.29,362.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountPassword);
export default __webpack_public_path__ + "static/media/user_account_password.b8afe36ee691c746735ca51ce4c8424d.svg";
export { ForwardRef as ReactComponent };